// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscriptioncompleted-container {
  display: flex;
  flex-direction: row;
  overflow-x: hidden;
  overflow-y: auto;
  height: 95vh;
  justify-content: center;
}
.subscriptioncompleted-container.select-plan {
  background-color: #fff;
}
.subscriptioncompleted-container .success-container {
  display: flex;
  flex-direction: column;
  width: 446px;
  justify-content: center;
  margin-left: 20px;
}
.subscriptioncompleted-container .success-container .success-title {
  margin-top: 30px;
  font-size: 48px;
  font-weight: 700;
  line-height: 56px;
  letter-spacing: -0.02em;
  text-align: left;
}
.subscriptioncompleted-container .success-container .success-message {
  margin-top: 30px;
  font-size: 24px;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: -0.02em;
  text-align: left;
}
.subscriptioncompleted-container .success-container .success-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: nowrap;
  margin-top: 30px;
}
.subscriptioncompleted-container .home {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.subscriptioncompleted-container .home > div > div.custom-content {
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/Components/SubscriptionCompleted/subscriptioncompleted.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;AACF;AACE;EACE,sBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;AAAJ;AAEI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAAN;AAGI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;AAFN;AAME;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAJJ;AAMI;EACE,YAAA;AAJN","sourcesContent":[".subscriptioncompleted-container {\n  display: flex;\n  flex-direction: row;\n  overflow-x: hidden;\n  overflow-y: auto;\n  height: 95vh;\n  justify-content: center;\n\n  &.select-plan {\n    background-color: #fff;\n  }\n\n  .success-container {\n    display: flex;\n    flex-direction: column;\n    width: 446px;\n    justify-content: center;\n    margin-left: 20px;\n\n    .success-title {\n      margin-top: 30px;\n      font-size: 48px;\n      font-weight: 700;\n      line-height: 56px;\n      letter-spacing: -0.02em;\n      text-align: left;\n    }\n\n    .success-message {\n      margin-top: 30px;\n      font-size: 24px;\n      font-weight: 400;\n      line-height: 36px;\n      letter-spacing: -0.02em;\n      text-align: left;\n    }\n\n    .success-buttons {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-evenly;\n      flex-wrap: nowrap;\n      margin-top: 30px;\n    }\n  }\n\n  .home {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    > div > div.custom-content {\n      height: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
